import RemoteLogger from './remoteLogger'
import Utils from './utils';

const BoundingBoxIframeClass = "bounding-box-iframe"
const RefreshStatusIframeClass = "refresh-status-iframe"
const PageLoadedIframeClass = "page-loaded-iframe"
const GeoLocInitiateIframeClass = "geo-loc-initiate-iframe"
const PullToRefreshIframeClass = "pull-to-refresh-iframe"
const SilentLocDetectionClass = "silent-loc-detection-iframe"
const RedirectToBillingIframeClass = "redirect-billing-iframe"
const RedirectToManageSubscriptionIframeClass = "redirect-manage-subscrip-iframe"
const InterstitialAdsClass = "interstitial-ads-iframe"
const ShareWithFriendsClass = "share-with-friends-iframe"

const BoundingBoxEndpoint = "inapp://bounding-box"
const RefreshStatusEndpoint = "inapp://refresh-status"
const PageLoadedEndpoint = "inapp://page-loaded"
const GeoLocInitiateEndpoint = "inapp://location/detect"
const PullToRefreshHandlerEndpoint = "inapp://pull-to-refresh"
const SilentLocationDetectionEndpoint = "inapp://location/silent-detect"
const RedirectToBillingEndpoint = "inapp://redirect-to-billing"
const RedirectToManageSubscriptionEndpoint = "inapp://redirect-to-manage-subscription"
const InterstitialAdsDetectionEndpoint = "inapp://open-interstitial-ads"
const ShareWithFriendsEnpoint= "inapp://share-app"

class NativeAgent {
    addBlackListBounds(boxListStr) {
        console.log("BOUNDING-BOX: Calling native update black listed bounds")
        let src = BoundingBoxEndpoint + "?data=" + encodeURIComponent(boxListStr);
        this.loadIframeIntoDom(BoundingBoxIframeClass, src)
    }

    updateRefreshManagerStatus(updateStr) {
        console.log("REFRESH: Calling native update-refresh-status")
        let src = RefreshStatusEndpoint + "?data=" + encodeURIComponent(updateStr);
        this.loadIframeIntoDom(RefreshStatusIframeClass, src)
    }

    sendPageLoadedStatus() {
        console.log("PAGE-LOAD: Calling native send-page-loaded-status")
        this.loadIframeIntoDom(PageLoadedIframeClass, PageLoadedEndpoint)
    }

    initiateDetectLocation() {
        console.log("GEO: Calling native detect-loc")
        this.loadIframeIntoDom(GeoLocInitiateIframeClass, GeoLocInitiateEndpoint)
    }

    initiateSilentLocationDetection() {
        console.log("LOCA: Calling silent detect-loc")
        this.loadIframeIntoDom(SilentLocDetectionClass, SilentLocationDetectionEndpoint)
    }

    redirectToBilling() {
        console.log("Redirect to Billing")
        this.loadIframeIntoDom(RedirectToBillingIframeClass, RedirectToBillingEndpoint)
    }

    redirectToManageSubscription() {
        console.log("Redirect to Manage Subscription")
        this.loadIframeIntoDom(RedirectToManageSubscriptionIframeClass, RedirectToManageSubscriptionEndpoint)
    }

    initiateInterstitialAdsCall(newsUrl) {
        console.log("Interstitial Ads: Calling native")
        let src = InterstitialAdsDetectionEndpoint + "?news_url=" + encodeURIComponent(newsUrl)
        this.loadIframeIntoDom(InterstitialAdsClass, src)
    }
    sendShareWithFriendsCall() {
        console.log("Share with friends : Calling native")
        let src = ShareWithFriendsEnpoint
        this.loadIframeIntoDom(ShareWithFriendsClass, src)
    }

    loadIframeIntoDom(iframeClass, srcEndpoint) {
        // Remove the exisiting iframes
        try {
            let iframeClassList = document.querySelectorAll("." + iframeClass)
            if (false === Utils.isNull(iframeClassList)) {
                [...iframeClassList].forEach(function (clsObj) {
                    try {
                        clsObj.remove()
                    } catch (e) {
                        console.log("error removing exisiting entries")
                    }
                })
            }

            // Add the iframe to the source
            var src = srcEndpoint

            var iframe = document.createElement("iframe");
            iframe.style.display = "none"
            iframe.src = src
            iframe.setAttribute("class", iframeClass)
            document.body.appendChild(iframe)
        } catch (e) {
            console.log("Exception found - ", e)
            RemoteLogger.log(e)
        }
    }

    updatePullToRefresh(isRefreshEnabled) {
        let src = PullToRefreshHandlerEndpoint + "?enabled=" + ((isRefreshEnabled === true) ? "1" : "0");
        this.loadIframeIntoDom(PullToRefreshIframeClass, src)
    }
}

let instance = new NativeAgent()
export default instance



// WEBPACK FOOTER //
// ./src/common/nativeAgent.js